import { Tooltip } from 'react-bootstrap'
import styled from 'styled-components'

export const StyledFileUploader = styled.div<{ $disabled?: boolean }>`
  .place-holder {
    border: 2px dashed ${({ $disabled }) => ($disabled ? '#ccc' : '#ccc')};
    border-radius: 5px;
    padding: 20px;
    text-align: center;
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    margin-bottom: 10px;
    background-color: ${({ $disabled }) => ($disabled ? '#f5f5f5' : 'transparent')};
    opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
    pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  }

  .plus-icon {
    font-size: 24px;
    margin-right: 10px;
    color: ${({ $disabled }) => ($disabled ? '#aaa' : '#003399')};
  }

  .file-name {
    display: inline-block;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }

  .remove-file-btn {
    cursor: pointer;
    color: red;
    margin-left: 5px;
    font-size: 14px;
  }

  .file-notes-label {
    font-size: 12px;
    padding-top: 8px;
  }
`

export const StyledDropZone = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledFileTooltip = styled(Tooltip)`
  opacity: 1 !important;

  .tooltip-inner {
    color: black;
    font-size: 14px;
    max-width: 300px;
    background-color: white;
    box-shadow: rgb(0 0 0 / 15%) 0px 2px 4px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  .arrow::before {
    border-style: none;
  }
`
